module.exports = __webpack_public_path__ + "static/media/server-error.b57e3574.svg";